export type SocialNetwork =
  | 'instagram'
  | 'facebook'
  | 'twitter'
  | 'youtube'
  | 'tiktok'
  | 'snapchat'
  | 'google'
  | 'maji'
  | 'argo'
  | 'reddit'
  | 'spotify'
  | 'website';

export type SocialNetworkInfo = {
  title: string;
  icon: string;
};

export const SocialNetworkIcons: {
  [x in SocialNetwork]: SocialNetworkInfo;
} = {
  instagram: { title: 'Instagram', icon: 'instagram' },
  facebook: { title: 'Facebook', icon: 'facebook' },
  twitter: { title: 'Twitter', icon: 'twitter' },
  youtube: { title: 'Youtube', icon: 'youtube' },
  tiktok: { title: 'TikTok', icon: 'tiktok' },
  snapchat: { title: 'Snapchat', icon: 'snapchat' },
  google: { title: 'Google', icon: 'google' },
  maji: { title: 'Maji', icon: 'maji' },
  argo: { title: 'Argo', icon: 'argo' },
  reddit: { title: 'Reddit', icon: 'reddit' },
  spotify: { title: 'Spotify', icon: 'spotify' },
  website: { title: 'Website', icon: 'website' },
};
